<template>
  <div>

    <nao-encontrado v-if="naoEncomtrado" :leilaoId="leilao.id" :cookie="cookie"></nao-encontrado><!-- MENSAGEM DE NÃO ENCONTRADO -->

    <div
      v-show="loadingPage === false && naoEncomtrado === false"
      class="w-full px-8 2xl:px-56 md:py-16 py-8 justify-center grid grid-cols-1 space-y-8 md:space-y-0 md:gap-8 gap-4 bg-jrGray-60"><!-- LISTAGEM --- SALA DE DISPUTA -->

      <bread-crumb :categorialeilao="leilao.categorialeilao" :nomeLeilao="leilao.nm"></bread-crumb>

      <header-disputa :dadosLeilao="leilao" :leilaoid="leilaoId" :lotes="lotes"></header-disputa><!-- CABEÇALHO LEILAO -->

      <mensagem-box :message="message" :liberado="liberado" :usuario="usuario"></mensagem-box>

      <Stretch v-show="loadingRefresh">Carregando...</Stretch><!-- LOAD DE CONTEUDO -->

      <!-- FILTROS
      <filtro :leilao="leilao" :filtros="filtros"></filtro><br>-->

      <!-- Formatação dos lotes/Atualização -->
      <div class="hidden xl:flex justify-end items-center mb-6">
        <div class="flex bg-white p-5 rounded-md gap-3 text-gray-500" v-show="leilao.statusleilao_id !== 17">
          <router-link :to="`/leilao/index/leilao_id/${leilaoId}`" title="Mostrar formato carta">
            <i class="icon-cards hover:text-jrBlue-100"></i>
          </router-link>
          <router-link :to="`/leilao/index/listagem/leilao_id/${leilaoId}`" title="Mostrar formato lista">
            <i class="icon-menu text-jrBlue-100"></i>
          </router-link>
          <a href @click="refreshPage" title="Atualizar todos os lotes"><i class="icon-refresh hover:text-jrBlue-100"></i></a>
        </div>
      </div>

        <!-- LOTES EM LISTA -->
        <div v-show="firstLoadListagem === false && loadingRefresh === false">
          <ul class="flex justify-center items-center flex-wrap gap-20">
            <li v-for="(lote,idx) in lotes" :key="idx" class="flex w-full text-jrBlue-100 bg-white rounded-xl" >
              <Item :statusleilao_id="leilao.statusleilao_id" :leilao="leilao" :dados="lote" :liberado="liberado" :automatico="fechamento" :usuarioid="usuario.id" :status="leilao.nm_status"></Item>
            </li>
          </ul>
        </div>

        <div class="w-full flex justify-center">
          <button class="flex items-center bg-jrBlue-100 text-white px-2.5 py-2 rounded-md hover:bg-jrBlue-50">Carregar mais<i class="icon-refresh ml-2 flex items-center"></i></button>
        </div>
    </div>
  </div>
</template>

<script>
// PLUGIN COMPONENTS
import Paginate from 'vuejs-paginate'
import {Stretch} from 'vue-loading-spinner'
import { Carousel, Slide } from 'vue-carousel'

// LAYOUT COMPONENTS
import Item from '@/components/shared/Item'
import BreadCrumb from '@/components/shared/BreadCrumb'
import BotoesRotas from '@/components/shared/BotoesRotas'
import NaoEncontrado from '@/components/shared/NaoEncontrado'
import HeaderDisputa from '@/components/shared/HeaderDisputa'
import MensagemBox from '@/components/shared/MensagemBox'
import MensagemBoxLeilao from '@/components/shared/MensagemBoxLeilao'
import Filtro from '@/components/shared/Filtro'

export default {
  name: 'Listagem',
  props:["dadosLeilao"],
  components:{
    BreadCrumb,
    Item,
    Stretch,
    Paginate,
    Carousel,
    Slide,
    BotoesRotas,
    NaoEncontrado,
    HeaderDisputa,
    MensagemBox,
    MensagemBoxLeilao,
    Filtro
  },
  data () {
    return {
      leilaoId: this.$route.params.id,
      lote_id_pregao: null,
      leilao: {},
      lotes: [],
      visitas: [],
      lotesAcompanhar: [],
      lotesPregao: [],
      config_leiloeiro: [],
      dados_condicao: [],
      usuario: [],
      paginator: { pageCount: 1, countLote: 0},
      filtros: [],
      errors: [],
      lotesStatusReference: [],
      lotesLanceReference: [],
      lotesIncrementoReference: [],
      lotesDtfechamentoReference: [],
      dadosRequisicao: { isLogado: false },
      value_video: null,
      loadingPage: true,
      loadingRefresh: false,
      naoEncomtrado: false,
      firstLoadListagem: true,
      paginaAtual:0,
      seguir: false,
      message: '',
      liberado: false,
      fechamento: false,
      parametrosFiltro: '',
      refreshSalaDisputa:null,
      refreshCountSalaDisputa: 30000,
      cookie: true,
      numeroRegistrosPorPagina: 32,
      saladisputa: null
    }
  },
  methods:{
    getWindowWidth() {
      return window.innerWidth;
    },
    actionSeguir() { // AÇÃO DE SEGUIR LEILOEIRO
      if (this.seguir) {
        this.saladisputa.ordenaLotesPorSeq(this.lotes)
        this.saladisputa.carregaLoteEmPregao(
          this.lote_id_pregao,
          this.leilaoId
        )
      } else {
        // ordena por seq
        this.saladisputa.ordenaLotesPorSeq(this.lotes)
      }
    },
    seguirLeiloeiro(ev) { // TOGGLE TRUE/FALSE E ALTERA MODEL LOTES ONCLICK
      this.seguir = !this.seguir;
      this.actionSeguir()
    },
    callData (pageNumber,FiltroLoad) { // REQUEST DOS DADOS LISTAGEM - SALA DE DISPUTA
      if (this.$route.query.page) {
          this.paginaAtual = parseInt(this.$route.query.page)
      } else {
          this.paginaAtual = 0
      }
      this.loadingPage = true
      this.loadingRefresh = true
      const hostName = location.protocol + "//"+window.HOSTNAME

      this.saladisputa.refreshLotesListagem();
      this.saladisputa.calculaQtdePaginas()

      let pageNum = 1;
      let changeFiltro = null;
      this.loadingPage = false;
      this.loadingRefresh = false;
      this.firstLoadListagem = false;
      this.leilao = this.dadosLeilao
    },
    clickCallback(pageNum) {
      // ATUALIZA O NÚMERO DA PÁGINA ATUAL PARA AMBOS (PAGINACAO)
      this.$router.push({ query: { page: pageNum } });
      this.paginaAtual = pageNum;
      this.saladisputa.refreshLotesListagem();
      this.$forceUpdate();
      // this.$refs.paginate1.selected = this.$refs.paginate2.selected = pageNum - 1;
      //this.$refs.ancora.scrollIntoView({ behavior: "smooth" });
    },
    refreshPage (ev){ // REFRESH
      this.loadingRefresh = true
      this.callData()
    },
    refreshFirebase() {

    },
    refreshDadosGerais(_self) {
      const hostName = location.protocol + "//"+window.HOSTNAME
      var self = this;

      // usuario (favorito)
      fetch(`${hostName}/leilao/get-dados-gerais?leilao_id=${this.leilaoId}`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then((res) => {
          //console.log('3');
          self.usuario = res.usuario
          self.visitas = res.visitas

          self.saladisputa.configuraFavoritos(_self)
          self.saladisputa.configuraVisitas()
        });
    }
  },
  watch: {
    'dadosLeilao'(novo, ant) {
      this.leilao = this.dadosLeilao
    }
  },
  created () { // INIT
    this.$vs.loading({background:'#fff',color:'#67302B'})

    //dados vindo do props
    this.leilao = this.dadosLeilao
    clearInterval(window.INTERVALO_BUSCA)
    clearInterval(window.INTERVALO_CATEGORIA)

    this.saladisputa = new window.saladisputa(this)
    this.saladisputa.loading_opened = true;
    this.saladisputa.registraLotePregao()
    this.callData()

    // RECEBE INFORMAÇÕES DO COMPONENT shared/Filtro.vue    por meio de $on <= $emit
    this.$on('filtroChange', function (dadosFiltro) {
      let parametros = ''
      if(dadosFiltro.filtro1 !== ''){
        parametros += `segmento_id=${dadosFiltro.filtro1}`
      }else{
        parametros = ''
      }

      if(dadosFiltro.filtro2 !== ''){  parametros += `&filtro1=${dadosFiltro.filtro2}` }
      if(dadosFiltro.filtro3 !== ''){  parametros += `&filtro2=${dadosFiltro.filtro3}` }
      if(dadosFiltro.filtro4 !== ''){  parametros += `&filtro3=${dadosFiltro.filtro4}` }
      if(dadosFiltro.filtro5 !== ''){  parametros += `&filtro4=${dadosFiltro.filtro5}` }

      this.parametrosFiltro = parametros

      //filtro
      this.saladisputa.filtrarAction()
    })

    this.$on('dados-gerais', function(data) {
      this.config_leiloeiro = data.config_leiloeiro
      this.dados_condicao = data.dados_condicao
      this.usuario = data.usuario
      this.visitas = data.visitas
      this.dadosRequisicao.leilaoId = this.leilao.id
      this.dadosRequisicao.isLogado = this.usuario.id !== null ? true : false

      this.saladisputa.configuraFavoritos()
      this.saladisputa.configuraVisitas()

      this.$vs.loading.close();
      this.loadfiltro = true;


    });

    this.$on('favoritoModificado', function (_self) {
      this.refreshDadosGerais(_self)
    })

    this.$on('loteIdAtualChange',function (id){
      this.dadosRequisicao.loteId = id !== null ? id : this.lotes[0].lote_id
      sessionStorage.setItem('loteId', id);
    })

    this.$on('liberacaoMensagem',function(json){
      this.message = json.message
      this.liberado = json.liberado
      this.fechamento = json.fechamento  // leilao.bn_fechamentoautomatico
    })

    this.cookie = this.$root.cookieAtivo
    this.$root.MensagemBrowserCookie()
  }
}
</script>

<style>
  /* EFEITO DE TRANSIÇÃO*/
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to{
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Listagem.vue